<template>
  <div class="home">
    <top-bar></top-bar>
    <mobile-nav v-if="isMobile" :edu="edu" :space="space"></mobile-nav>
    <nav-bar v-if="!isMobile" :edu="edu" :space="space"></nav-bar>
    <div class="slider-container">
      <Slider></Slider>
    </div>
    <div class="news-container">
      <news-info :news="news"></news-info>
    </div>
    <div class="edu-container">
      <education-info :edu="edu"></education-info>
    </div>
    <space-info :space="space"></space-info>
    <Footer></Footer>
  </div>
</template>

<script>
// @ is an alias to /src
import TopBar from '@/components/TopBar.vue'
import NavBar from '@/components/NavBar.vue'
import Slider from '@/components/Slider.vue'
import NewsInfo from '@/components/NewsInfo.vue'
import EducationInfo from '@/components/EducationInfo.vue'
import SpaceInfo from '@/components/SpaceInfo.vue'
import Footer from '@/components/Footer.vue'
import MobileNav from '@/components/MobileNav.vue'

export default {
  computed: {
    isMobile () {
      return /Android|Windows Phone|iPhone|iPod/i.test(navigator.userAgent)
    }
  },
  data () {
    return {
      news: [],
      edu: [],
      space: []
    }
  },
  name: 'Home',
  components: {
    TopBar,
    NavBar,
    Slider,
    NewsInfo,
    EducationInfo,
    SpaceInfo,
    Footer,
    MobileNav
  },
  mounted () {
    this.getInfoType()
    this.$nextTick(() => {
      new this.$wow.WOW().init()
    })
  },
  methods: {
    getInfoType () {
      this.$axios.get(process.env.VUE_APP_jiaxingUrl + '/system/open/titleList').then(res => {
        const data = res.data
        this.news = data.news
        this.edu = data.edu
        this.space = data.space
        window.localStorage.setItem('typeObj', JSON.stringify(data))
      })
    }
  }
}
</script>

<style scoped lang="scss">
.slider-container {
  margin: 20px auto 0;
  width: 1200px;
}
.news-container {
  margin-top: 52px;
}
.edu-container {
  margin-top: 180px;
}
</style>
